export default __webpack_public_path__ + "static/sac5.mobile.inspirations-6873600995e0139a1baa0879beae504e.jpg";